import axios from 'axios';
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { ClientFilterDto, IClient, IClientRequest } from "@ontime/types";

const API_URL = (organizationId: string) => `${ApiURL()}/organizations/${organizationId}/client`;

class ClientService {

    async GetList(organizationId: string, filters: ClientFilterDto): Promise<IClient[]> {
        console.log('ClientFilterDto', filters)
        const response = await axios.get<IClient[]>(API_URL(organizationId), {
            headers: AuthHeader(),
            params: filters
        });
        return response.data;
    }

    async Get(organizationId: string, clientId: string): Promise<IClient> {
        const response = await axios.get<IClient>(`${API_URL(organizationId)}/${clientId}`, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Create(organizationId: string, input: IClientRequest): Promise<IClient> {
        const response = await axios.post<IClient>(API_URL(organizationId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Update(organizationId: string, input: IClientRequest): Promise<IClient> {
        const response = await axios.put<IClient>(API_URL(organizationId), input, {
            headers: AuthHeader(),
        });
        return response.data;
    }

    async Delete(organizationId: string, clientId: string, currentIsDeleted: boolean): Promise<{ clientId: string }> {
        const response = await axios.delete<{ clientId: string }>(`${API_URL(organizationId)}/${clientId}`, {
            headers: AuthHeader(),
            params: { currentIsDeleted }
        });
        return response.data;
    }
}

export default new ClientService();